import React from "react"

export default function Reply() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <path d="M23.9826 8.9008L15.7324 0.758753C15.0102 0.0459865 13.8721 0.624611 13.8721 1.73182V6.02037C6.34259 6.11889 0.372074 7.84351 0.372074 15.9985C0.372074 19.2899 2.22743 22.5507 4.27831 24.2555C4.91829 24.7875 5.83039 24.1198 5.59442 23.2574C3.46892 15.4889 6.60256 13.4266 13.8721 13.307V18.0167C13.8721 19.1256 15.0111 19.7017 15.7324 18.9898L23.9826 10.8469C24.5015 10.3347 24.5022 9.41374 23.9826 8.9008Z" fill="#705ec9" />
      </svg>
   )
}
